import React, { useState, useEffect, useMemo } from "react"
import { CircularProgress, Typography } from "@material-ui/core"
import { useDispatch } from "react-redux"
import { getCrewDealMemo } from "../../actions/billing-crew-client"
import { isEmpty } from "lodash"
import billingTheme from "../../themes/billing"
import { MuiThemeProvider } from "@material-ui/core/styles"
import BillingPageLayout from "../../components/Billing/Common/BillingPageLayout/index"
import CrewmamaAppBar from "../../components/CrewmamaAppBar/index"
import useStyles from "./styles"
import CrewDealMemoActions from "../../components/Billing/Crew/CrewDealMemoActions/index"
import CrewDealMemoCard from "../../components/Billing/Crew/CrewDealMemoCard/index"

const DealMemoPageContent = props => {
  const dispatch = useDispatch()

  let shortCode = props.match.params.short_code

  // the local source of truth for crew deal memo & all child components
  const [crewDealMemo, setCrewDealMemo] = useState({})
  const [error, setError] = useState("")

  // Make call to populate the state val being used in the tables, etc.
  useEffect(() => {
    dispatch(getCrewDealMemo(shortCode))
      .then(res => {
        setCrewDealMemo(res)
        return res
      })
      .catch(err => {
        console.log(err)
        setError("No data to display.")
      })
  }, [])

  // isolated crew member's user object, which includes expenses, etc.
  const crewMember = useMemo(
    () => {
      if (crewDealMemo && crewDealMemo.user) {
        return { ...crewDealMemo.user, shoot_id: crewDealMemo.shoot_id }
      }
    },
    [crewDealMemo]
  )

  if ((isEmpty(crewDealMemo) || !crewMember) && !error) {
    return <CircularProgress />
  } else if (error) {
    return (
      <Typography variant="h4" style={{ marginTop: "20px" }}>
        {error}
      </Typography>
    )
  } else {
    return (
      <BillingPageLayout
        leftHeader={`Deal Memo for ${crewDealMemo.shoot_name}`}
        leftContent={<CrewDealMemoCard crewMember={crewMember} />}
        rightHeader={crewMember.user_status === "sent" ? "Actions" : "Status"}
        // rightSubtitle={
        //   crewMember && crewMember.user_status === "sent"
        //     ? "Please make sure the following have been submitted to Crew Mama in order to accept this deal memo:"
        //     : null
        // }
        rightContent={
          <CrewDealMemoActions
            crewMember={crewMember}
            crewDealMemo={crewDealMemo}
            setCrewDealMemo={setCrewDealMemo}
          />
        }
      />
    )
  }
}

export const DealMemoPage = props => {
  return (
    <MuiThemeProvider theme={billingTheme}>
      <CrewmamaAppBar />
      <DealMemoPageContent {...props} />
    </MuiThemeProvider>
  )
}

export default DealMemoPage
